import {default as AjaxPage, LoadState} from "./AjaxPage";

export default interface AjaxPageConfig {
	// NOTE: If you add more properties set a default on DefaultAjaxPageConfig below, and the equal function.
	isIframeLoadingOrContentSelector?: string|boolean; // Query selector to indicate what part of the page to load.
	closeButtonText?: string,
	onLoadStateChange?: (ajaxPage: AjaxPage, loadState: LoadState) => void,
	requestParams?: {[key: string]: string}
}

export const defaultAjaxPageConfig = {
	isIframeLoadingOrContentSelector: true,
	closeButtonText: ""
};

export function equal(config1: AjaxPageConfig, config2: AjaxPageConfig) {
	return (
		config1.isIframeLoadingOrContentSelector === config2.isIframeLoadingOrContentSelector
		&& config1.closeButtonText === config2.closeButtonText
	);
}